import { render, staticRenderFns } from "./DetailOrder.vue?vue&type=template&id=443a88e1&scoped=true&lang=pug&"
import script from "./DetailOrder.vue?vue&type=script&lang=js&"
export * from "./DetailOrder.vue?vue&type=script&lang=js&"
import style0 from "./DetailOrder.scss?vue&type=style&index=0&id=443a88e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443a88e1",
  null
  
)

export default component.exports